import React, { useState, useEffect,useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import './CvSearch.css';
import { IoSearchOutline } from 'react-icons/io5';
import { MdOutlineMenu, MdArrowForward } from 'react-icons/md';
import { BsClock, BsBoxes } from 'react-icons/bs';
import AxiosService from "../../../Utils/AxiosService";

const CvSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [datasets, setDatasets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const apiService = useMemo(() => new AxiosService(), []);
  useEffect(() => {
    fetchClassificationData();
  }, []);

const fetchClassificationData = async () => {
  try {
    setLoading(true);
    setError(null);

    const response = await apiService.fetchRefDataClassification();

    // Axios already returns parsed JSON
    const data = response.data;

    console.log("API Response:", data);

    const transformedData = data.map((item) => ({
      id: item.classificationId,
      title: item.classificationName,
      urn: `urn:croplife-dlc-de:${item.classificationName.toLowerCase()}`,
      contains: item.refDataTypes.map((ref) => ref.refClassName),
      entityTypes: item.refDataTypes.map((ref) => ref.entityType),
    }));

    setDatasets(transformedData);
  } catch (err) {
    console.error("Error fetching classification data:", err);
    setError(err.message || "Failed to fetch data");
    setDatasets([]);
  } finally {
    setLoading(false);
  }
};

  const filteredDatasets = datasets.filter(dataset =>
    dataset.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    dataset.urn.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCardClick = async (dataset) => {
    try {
      const response = await apiService.fetchRefDataValuesByClassification(dataset.id);
      navigate(`/refdataDetails/${dataset.id}`, {
        state: {
          dataset,
          refDataValues: response.data,
          classificationId: dataset.id,
          entityType: dataset.entityTypes || [],
          territory: "",
          searchTerm: searchTerm
        }
      });
    } catch (error) {
      console.error('Error fetching ref data values:', error);
      navigate(`/refdataDetails/${dataset.id}`, {
        state: {
          dataset,
          classificationId: dataset.id,
          entityType: dataset.entityTypes || [],
          territory: "",
          searchTerm: searchTerm
        }
      });
    }
  };

  return (
    <div className="cv-search-container">
      <div className="search-header">
        <div className="search-bar-wrapper">
          <IoSearchOutline className="search-icon" />
          <input
            type="text"
            className="search-input"
            placeholder="Search in all your datasets..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        {/* <div className="header-actions">
          <MdOutlineMenu className="menu-icon" />
          <MdArrowForward className="arrow-icon" />
        </div> */}
      </div>

      {loading && <div className="loading-message">Loading classifications...</div>}
      {error && <div className="error-message">Error loading data: {error}</div>}

      <div className="datasets-grid">
        {filteredDatasets.map((dataset) => (
          <div key={dataset.id} className="dataset-card" onClick={() => handleCardClick(dataset)} style={{ cursor: 'pointer' }}>
            <div className="card-header">
              <h3 className="card-title">{dataset.title}</h3>
              <p className="card-urn">{dataset.urn}</p>
            </div>

            <div className="contains-section">
              <p className="section-label">Contains</p>
              <p className="contains-list">
                {dataset.contains.join(', ')}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CvSearch;
